// @ts-nocheck
/* eslint-disable */
import SceneMarkerMapyWindy from "./mapy-windy";

export default class SceneMarkerMapyWindyDetailclass extends SceneMarkerMapyWindy {
	/**
	 * Vytvoreni Windy markeru pro detail.
	 *
	 * @param  {Object} poi Vstupni POI data
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, poi?, opts?) {
		super(scene, itemId, coords, null, opts);

		this._poi = poi;
		this._title = "";
		this._titlePosition = "";
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerMapyWindyDetail",
			type: "marker"
		};
	}

	get titlePosition() {
		return this._titlePosition;
	}

	/**
	 * Naplneni dat markeru z POI dat.
	 *
	 * @param  {Object} poi POI data
	 * @param  {String|Number} id Vlastni id
	 * @param  {Object} opts Konfigurace
	 */
	fromPOI(poi, id, opts) {
		this._coords = this._scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat);
		this._id = id || this._id;
		this._poi = poi;

		let params = {
			type: this._scene.VISUAL.MARKER_WINDY.BIG || {}
		};

		if (opts && opts.m3dData) {
			this.updateM3dData(opts.m3dData);
			delete opts.m3dData;
		}

		this._titlePosition = opts.fromMarker?.titlePosition ? opts.fromMarker.titlePosition : "right";

		Object.assign(this._conf, Object.assign(params, opts));

		this._fromPOI = {
			poi: poi,
			id: id,
			opts: opts
		};
	}
}
